import { useState, useEffect } from 'react'

const scrollTrigger = options => {
  const { threshold, target } = options
  let verticalScroll

  if (target) {
    verticalScroll = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop
  }

  return verticalScroll > threshold
}

const defaultTarget = typeof window !== 'undefined' ? window : null

/** @type {import("./types.d").default} */
const useScrollTrigger = (options = {}) => {
  const { target = defaultTarget, threshold = 100 } = options
  const [trigger, setTrigger] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setTrigger(scrollTrigger({ target, threshold }))
    }

    handleScroll()
    if (target) {
      target.addEventListener('scroll', handleScroll)
      return () => {
        target.removeEventListener('scroll', handleScroll)
      }
    }
  }, [target, threshold])

  return trigger
}

export default useScrollTrigger
